'use client';

import React, { useState } from 'react';
import styles from '../footer.module.scss';
import Cookies from 'js-cookie';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  getBlindMode,
  toggleBlindMode,
} from '../../../../../store/slices/blind-mode.slices';

enum ButtonText {
  BLIND = 'Версия для слабовидящих',
  USUALLY = 'Обычная версия',
}

export const ButtonBlindFooter = () => {
  const dispatch = useAppDispatch();
  const { blindWrapClass } = useAppSelector(getBlindMode);

  const onClickBtnBlind = () => {
    dispatch(toggleBlindMode());
  };

  return (
    <button className={styles.blindBtn} id={'blindFooter'} onClick={onClickBtnBlind}>
      {blindWrapClass ? ButtonText.USUALLY : ButtonText.BLIND}
    </button>
  );
};
